export default __webpack_public_path__ + "static/media/Hra.c15a4146.svg";